/**
 * Override: Restore the v16.0.0 user avatar dropdown behavior.
 *
 * In Frappe v16.0.0, the sidebar user avatar was a <button> with
 * data-toggle="dropdown" that triggered a Bootstrap dropdown containing
 * navbar_settings.settings_dropdown items plus standard items (User Settings,
 * Log out). In later releases, this was removed — the avatar just links to
 * user profile, and Logout moved to the sidebar header dropdown.
 *
 * This override restores the original dropdown with all items.
 */

frappe.provide("eternal_support");

$(document).on("app_ready", function () {
	// Patch sidebar header to prevent settings_dropdown from going to header menu
	if (frappe.ui.SidebarHeader && !frappe.ui.SidebarHeader.__es_patched) {
		frappe.ui.SidebarHeader.prototype.add_navbar_items = function () {
			// No-op — items belong in user avatar dropdown
		};
		frappe.ui.SidebarHeader.__es_patched = true;
	}

	// Setup the user dropdown
	eternal_support._restore_user_dropdown();
});

// Re-setup on sidebar rebuild
$(document).on("sidebar_setup", function () {
	setTimeout(() => {
		eternal_support._restore_user_dropdown();
	}, 400);
});

eternal_support._restore_user_dropdown = function () {
	const $container = $(".dropdown-navbar-user");
	if (!$container.length) return;

	// Prevent duplicate setup
	if ($container.data("es-dropdown-restored")) return;
	$container.data("es-dropdown-restored", true);

	// Get the current <a> element (sidebar-user-button)
	const $current_btn = $container.find("a.sidebar-user-button, a.nav-link");
	if (!$current_btn.length) return;

	// Extract the avatar and user info HTML
	const avatar_html = $current_btn.find("div").first().html() || "";
	const $name_email = $current_btn.find(".avatar-name-email");
	const name_email_html = $name_email.length ? $name_email.prop("outerHTML") : "";

	// Replace the <a> with a <button data-toggle="dropdown">
	const $new_btn = $(`
		<button
			class="align-center btn-reset flex nav-link sidebar-user-button"
			style="width: 100%; min-height: 40px;"
			data-toggle="dropdown"
			data-display="static"
			aria-haspopup="true"
			aria-expanded="false"
			aria-label="${__("User Menu")}"
		>
			<div>${avatar_html}</div>
			${name_email_html}
		</button>
	`);

	$current_btn.replaceWith($new_btn);

	// Build the dropdown menu items
	// First: include items from navbar_settings.settings_dropdown
	const settings_items = frappe.boot.navbar_settings?.settings_dropdown || [];
	let menu_html = "";

	// Add "User Settings" (standard item from v16.0.0)
	menu_html += `<button class="btn-reset dropdown-item" onclick="return frappe.ui.toolbar.route_to_user()">${__(
		"User Settings"
	)}</button>`;

	// Add divider if there are custom items
	if (settings_items.length > 0) {
		menu_html += `<div class="dropdown-divider"></div>`;
	}

	// Add settings_dropdown items from Navbar Settings
	settings_items.forEach((item) => {
		// Evaluate condition if present
		let condition = true;
		if (item.condition) {
			try {
				condition = eval(item.condition);
			} catch (e) {
				condition = true;
			}
		}

		if (!condition || item.hidden) return;

		if (item.route) {
			menu_html += `<a class="dropdown-item" href="${item.route}">${__(
				item.item_label
			)}</a>`;
		} else if (item.action) {
			menu_html += `<button class="btn-reset dropdown-item" onclick="return ${
				item.action
			}">${__(item.item_label)}</button>`;
		} else {
			menu_html += `<div class="dropdown-divider"></div>`;
		}
	});

	// Add divider before Logout
	menu_html += `<div class="dropdown-divider"></div>`;

	// Add "Log out" (standard item from v16.0.0)
	menu_html += `<button class="btn-reset dropdown-item" onclick="return frappe.app.logout()">${__(
		"Log out"
	)}</button>`;

	// Create and append the dropdown menu
	const $dropdown_menu = $(`
		<div class="dropdown-menu dropdown-menu-left" id="toolbar-user" role="menu">
			${menu_html}
		</div>
	`);

	// Remove any existing dropdown menu in the container
	$container.find(".dropdown-menu").remove();

	// Append the dropdown menu
	$container.append($dropdown_menu);

	// Initialize Bootstrap dropdown on the button
	if (typeof $new_btn.dropdown === "function") {
		$new_btn.dropdown();
	}

	// Also hide settings_dropdown items from the sidebar header context menu
	// (they may have been added before our patch took effect)
	eternal_support._hide_settings_from_header_menu();
};

eternal_support._hide_settings_from_header_menu = function () {
	const settings_items = frappe.boot.navbar_settings?.settings_dropdown || [];
	if (!settings_items.length) return;

	const labels_to_hide = new Set();
	settings_items.forEach((item) => {
		if (item.item_label) labels_to_hide.add(item.item_label.trim());
	});
	labels_to_hide.add("Logout");
	labels_to_hide.add("Log out");

	// Hide from sidebar-header-menu items
	$(".sidebar-header-menu .dropdown-menu-item").each(function () {
		const title = $(this).find(".menu-item-title").text().trim();
		if (labels_to_hide.has(title)) {
			$(this).css("display", "none");
		}
	});

	// Also hide the Logout item that's part of the sidebar header's dropdown_items
	// rendered via frappe.ui.create_menu (these end up in .frappe-menu elements on body)
	$(".frappe-menu .context-menu-item").each(function () {
		const title = $(this).find(".menu-item-title").text().trim();
		if (labels_to_hide.has(title)) {
			$(this).css("display", "none");
		}
	});
};
